import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import Root from './containers/Root/Root';
import * as serviceWorker from './serviceWorker';
import configureAppStore from './store/configureAppStore';

const { store, history } = configureAppStore();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<Root store={store} history={history} />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
